"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcAutocomplete = void 0;
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importStar(require("react"));
var react_autocomplete_1 = __importDefault(require("react-autocomplete"));
var react_bootstrap_1 = require("react-bootstrap");
var AcFormFieldErrorMessage_1 = require("../form/AcFormFieldErrorMessage");
var AcFormFieldLabel_1 = require("../form/AcFormFieldLabel");
var AcAutocomplete_module_scss_1 = __importDefault(require("./AcAutocomplete.module.scss"));
var AcAutocomplete = function (_a) {
    var formLabel = _a.formLabel, formInvalid = _a.formInvalid, formErrorId = _a.formErrorId, formReadOnly = _a.formReadOnly, required = _a.required, selectedItems = _a.selectedItems, chip = _a.chip, noData = _a.noData, props = __rest(_a, ["formLabel", "formInvalid", "formErrorId", "formReadOnly", "required", "selectedItems", "chip", "noData"]);
    var _b = __read(react_1.useState(false), 2), isOpen = _b[0], setIsOpen = _b[1];
    var renderInput = function (propsRI) {
        var inputEl = react_1.default.createElement("input", __assign({ className: "form-control" }, propsRI));
        if (selectedItems && selectedItems.length > 0) {
            inputEl = (react_1.default.createElement("div", { id: "field", className: "d-flex flex-wrap align-items-center border border-secondary bg-white overflow-auto " + (isOpen ? 'rounded-top-sm' : 'rounded-sm') },
                selectedItems.map(function (s, i) {
                    return chip(s, i);
                }),
                react_1.default.createElement("input", __assign({ className: "form-control border-0 d-flex flex-grow-1 w-auto shadow-none" }, propsRI))));
        }
        return (react_1.default.createElement(react_bootstrap_1.Form.Group, { className: clsx_1.default({ 'form-validation-error': formInvalid && formErrorId }) },
            react_1.default.createElement(AcFormFieldLabel_1.AcFormFieldLabel, { label: formLabel, readOnly: formReadOnly, required: required, type: "text" }),
            inputEl,
            formInvalid && formErrorId && !formReadOnly && (react_1.default.createElement(AcFormFieldErrorMessage_1.AcFormFieldErrorMessage, { messageId: formErrorId }))));
    };
    var renderMenu = function (menuItems, menuValue, menuStyle) {
        var predefinedMenuStyle = {
            top: '100%',
            left: 0,
        };
        if (menuValue && menuItems.length === 0) {
            return (react_1.default.createElement("div", { className: AcAutocomplete_module_scss_1.default.dropdown, style: __assign(__assign({}, menuStyle), predefinedMenuStyle) },
                noData && react_1.default.createElement(react_1.default.Fragment, null, noData),
                !noData && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "px-4 py-2 fs-14" }, "\u767B\u9332\u3055\u308C\u3066\u3044\u307E\u305B\u3093")))));
        }
        return (react_1.default.createElement("div", { className: AcAutocomplete_module_scss_1.default.dropdown, style: __assign(__assign({}, menuStyle), predefinedMenuStyle) }, menuItems));
    };
    var toggleDropdown = function (isOpen) { return setIsOpen(isOpen); };
    return (react_1.default.createElement(react_autocomplete_1.default, __assign({ wrapperStyle: { display: 'block', position: 'relative' }, renderInput: renderInput, renderMenu: renderMenu, onMenuVisibilityChange: function (isOpen) { return toggleDropdown(isOpen); } }, props)));
};
exports.AcAutocomplete = AcAutocomplete;
exports.AcAutocomplete.displayName = 'AcAutocomplete';
//# sourceMappingURL=AcAutocomplete.js.map